import { AppServices, Security } from '@singularsystems/neo-core'
import { IReportingConfig } from '@singularsystems/neo-reporting';
import { UserManagerSettings } from 'oidc-client-ts';
import { injectable } from 'inversify';
import { IAuthorisationConfig } from '@singularsystems/neo-authorisation';

@injectable()
export class AppConfig extends AppServices.ConfigModel {

    public static readonly silentSignInRoute = "/OidcSilentLoginRedirect";
    public static readonly loginRedirectRoute = "/OidcLoginRedirect";
    public userManagerSettings = {} as UserManagerSettings;

    public apiPath: string = "";
    public reportingApiPath: string = "";
    public authorisationServerApiPath: string = "";
    public identityServer = { client_id: "", url: "" };
    public applicationVersion: string = "";

    /**
     * Transforms property values loaded from config.json
     */
    public initialise() {
        this.apiPath = this.apiPath.replace("{domain}", window.location.hostname);
        this.reportingApiPath = this.reportingApiPath.replace("{domain}", window.location.hostname);
        this.authorisationServerApiPath = this.authorisationServerApiPath.replace("{domain}", window.location.hostname);
        this.identityServer.url = this.identityServer.url.replace("{domain}", window.location.hostname);

        this.loadUserManagerSettings();
    }

    private loadUserManagerSettings() {
        const window_redirect_uri = `${window.location.origin}${this.baseUrl}`;

        this.userManagerSettings = {
            client_id: this.identityServer.client_id,
            redirect_uri: `${window_redirect_uri}${AppConfig.loginRedirectRoute}`,
            response_type: 'code',
            scope: "openid profile STODAR.Domain IdentityServerApi Authorisation",
            authority: this.identityServer.url,
            silent_redirect_uri: `${window_redirect_uri}${AppConfig.silentSignInRoute}`,
            monitorSession: false,
            metadata: Security.OidcAuthService.createIdentityServerMetadata(this.identityServer.url)
        }
    }

    public get reportingConfig(): IReportingConfig {
        return {
            basePath: this.reportingApiPath,
            apiPath: `${this.reportingApiPath}api`,
            notificationDuration: 4,
            showPIIDownloadWarning: true,
        }
    }

    public get authorisationConfig(): IAuthorisationConfig {
        return {
            authorisationServerApiPath: this.authorisationServerApiPath
        }
    }
}